/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/index";
import SectionTitle from "../SectionTitle";
import "./Blog.css";
import blogImg1 from "../../images/Blog_imgs/blog-post-1.jpg";
import blogImg2 from "../../images/Blog_imgs/blog-post-2.jpg";
import blogImg3 from "../../images/Blog_imgs/blog-post-3.jpg";
import blogImg4 from "../../images/Blog_imgs/blog-post-4.jpg";
import Buttons from "../Buttons";
import { motion } from "framer-motion";

const Blog = () => {
  const desc =
    "TIPS, INSIGHTS, AND BEST PRACTICES ABOUT WEB DESIGN AND DEVELOPPMENT";
  const blogItems = [
    {
      id: 1,
      blogImg: blogImg1,
      blogTtle: "CREATE A WORDPRESS THEME FROM SCRATCH",
    },
    {
      id: 2,
      blogImg: blogImg2,
      blogTtle: "EFFECTIVE MARKETING STRATEGY TIPS",
    },
    {
      id: 3,
      blogImg: blogImg3,
      blogTtle: "FREE PSD AND SKETCH RESSOUCES",
    },
    {
      id: 4,
      blogImg: blogImg4,
      blogTtle: "HOW TO BECOME A SUCCESSFUL FREELANCER",
    },
    {
      id: 5,
      blogImg: blogImg1,
      blogTtle: "CREATE A WORDPRESS THEME FROM SCRATCH",
    },
    {
      id: 6,
      blogImg: blogImg2,
      blogTtle: "EFFECTIVE MARKETING STRATEGY TIPS",
    },
  ];
  const variants = {
    hidden: { opacity: 0, x: -1500, y: 0 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 1, x: 0, y: -200 },
  };
  useEffect(() => {
    document.querySelectorAll(".blog_img img").forEach((getimgSrc) => {
      getimgSrc.addEventListener("click", function (e) {
        const tget = e.target;
        const getsrc = tget.getAttribute("src");
        document.querySelector(".hoverImg img").setAttribute("src", getsrc);
        document.querySelector(".hoverImg").classList.add("shoeImgDesc");
        const blogdesc = tget.parentElement.parentElement;
        const h2 = blogdesc.querySelector(".blogtitle a h2");
        document.querySelector(".hoverImg .blogtitle a h2").innerHTML =
          h2.innerHTML;
      });
    });
  }, []);
  function remFun() {
    document.querySelector(".hoverImg").classList.remove("shoeImgDesc");
  }
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="enter"
      exit="exit"
      transition={{ type: "linear", duration: 0.5 }}
    >
      <section className="blog_area">
        <div className="container">
          <Navbar activeLi5={"activeLi"} />
          <SectionTitle sectitle={"LATEST"} clrTtle="POSTS" secDesc={desc} />
          <div className="blog_boxes">
            {blogItems.map((Bitems) => (
              <div className="blog_box" key={Bitems.id}>
                <div className="blog_img">
                  <img
                    src={Bitems.blogImg}
                    alt="blog img"
                    title="Click to Read The Full Blog"
                  />
                </div>
                <div className="blog_info">
                  <div className="blogtitle">
                    <Link to="/blog">
                      <h2>{Bitems.blogTtle}</h2>
                    </Link>
                  </div>
                  <div className="blog_desc">
                    <p>
                      Oki is a leading web design agency with an award-winning
                      design team that creates innovative...
                    </p>
                  </div>
                  <div className="section_btns">
                    <Buttons btntext={"Read More"} href="/blog" />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="hoverImg">
            <img />
            <div className="blogtitle">
              <Link to="/">
                <h2></h2>
              </Link>
            </div>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </p>
            <button className="deschide" onClick={remFun}>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Blog;
